/** regex */
export const regex = {
    deliveryNumber: '^[0-9]{10,18}$',
    zipCode: '^[0-9]{5}$',
    orderNumber: '^[0-9]{1,10}$',
    textArea: '^.{0,100}$',
    simNumber: '^[0]*(012[\\d]{5}|5[\\d]{7})$',
    addressFullName: '^.{1,40}$',
    addressStreet: '^.{1,49}$',
    addressHouseNo: '^.{1,10}$',
    addressCity: '^.{1,40}$',
    addressPostCode: '^[0-9]{5}$',
    hardwareArticleNumber: '^(1|3)[0-9]{5}$',
    simArticleNumber: '^((5[0-9]{7})|(12[0-9]{5}))$',
    semicolonCheck: /[;]/g,
    firstName: '^(?![\\s\\r\\n\\t\\f\\v]+$)(^[a-zA-ZÄäÖöÜüß.\-\\s]{1,25}$)',
    lastName: '(?![\\s\\r\\n\\t\\f\\v]+$)(^[a-zA-ZÄäÖöÜüß.\-\\s]{1,25}$)',
    houseNumber: '^(?=.*\\d)[a-zA-ZÄäÖöÜüß\\d]{1,5}$',
    umKabelCity: '^(?![\\s\\r\\n\\t\\f\\v]+$)(^[a-zA-ZÄäÖöÜüß.\-\\s]{1,25}$)',
    umKabelStreet: '(?![\\s\\r\\n\\t\\f\\v]+$)(^[a-zA-ZÄäÖöÜüß.\-\\s]{1,25}$)',
    contractNumber: '^[0-9]{1,11}$',
    phonePrefix: '^(0|\\+)([0-9]{2,7})$',
    mainPhone: '^[1-9]([0-9]{3,9})$',
    email: '^(?=.{1,64}@)[A-Za-z0-9_-]+(\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$',
    customerNumber: '^[1-9]([0-9]{8,10})$',
    cancelationReason: '^.{1,85}$',
    product: '^.{1,255}$',
    dslContractNumber: '^[A-Za-z0-9]{13}$',
    dslCustomerNumber:'^(00)[0-9]{10}$',
};
